export const TrackingStatusEnum = {
  NotTracked: 'not-tracked',
  NotVisited: 'not-visited',
  InProgress: 'in-progress',
  Completed: 'completed',
  Unknown: 'unknown',
} as const;

export type TrackingStatus = (typeof TrackingStatusEnum)[keyof typeof TrackingStatusEnum];
